import React from 'react'
import { Link } from 'react-router-dom'

const CourseCard = ({ course }) => {
    return (
        <div  className="user-right-body-block">
        <Link target="_blank" to={'/course-details/' + course.slug} className="ca_card_link">
            <div className="user-info-head">
                <img src={course.image} alt={course.title} />
            </div>
            <div className="user-info-desc">
                <h6>{course.title}</h6>
            </div>
        </Link>
    </div>
    )
}

export default CourseCard